import React, { useRef } from 'react';
import './ChangeTempoForm.scss';
import { Input } from '@availity/form';
import { Formik } from 'formik';
import { Col, Row } from 'reactstrap';
import * as yup from 'yup';
import {
    TimelineTempo,
    TimelineTempos,
} from '../../../../../slices/marketplace/timeline/models/enums/timeline-tempo.enum';
import Helpers from '../../../../../utils/helper';
import { LevelOfService } from '../../../../../slices/marketplace/timeline/models/enums/level-of-service.enum';

interface ChangeTempoFormProps {
    currentTempo: TimelineTempo;
    onClose: () => void;
    onSubmit: (selectedTempo: TimelineTempo) => void;
    totalFeeAmount: number;
    levelOfService: LevelOfService;
    isFree: boolean;
}

export const ChangeTempoForm = (props: ChangeTempoFormProps) => {
    const formRef = useRef<any>();
    const currentTempoName = TimelineTempos.find(
        (item) => item.id === props.currentTempo
    ).name;

    return (
        <div className="tempo-change-form">
            <div>
                <Formik
                    innerRef={formRef}
                    initialValues={{
                        tempo: '-1',
                    }}
                    validationSchema={yup.object().shape({
                        tempo: yup
                            .string()
                            .required('Tempo is required')
                            .notOneOf(['-1'], 'Tempo is required'),
                    })}
                    onSubmit={async (values) => {
                        const tempo = Number(values.tempo) as TimelineTempo;
                        props.onSubmit(tempo);
                    }}>
                    {({ values }) => {
                        return (
                            <div>
                                <Row className="mb-3">
                                    <Col md={4}>
                                        <label>Current Tempo:</label>
                                    </Col>
                                    <Col md={6}>
                                        <span>{currentTempoName}</span>
                                    </Col>
                                </Row>
                                <Row className="mb-3 align-items-center">
                                    <Col md={4}>
                                        <label>New Tempo:</label>
                                    </Col>
                                    <Col md={6}>
                                        <Input type="select" name="tempo">
                                            <option value={-1}>Select</option>
                                            {TimelineTempos.filter(
                                                (item) =>
                                                    item.id !==
                                                    props.currentTempo
                                            ).map((item) => (
                                                <option
                                                    value={item.id}
                                                    key={
                                                        'timelineTempo' +
                                                        item.id
                                                    }>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </Input>
                                    </Col>
                                </Row>
                                {!props.isFree && (
                                    <Row className="mb-4">
                                        <Col md={4}>
                                            <label> Fee:</label>
                                        </Col>
                                        <Col md={6}>
                                            <span>
                                                {Helpers.GetCurrencyFormat(
                                                    props.totalFeeAmount,
                                                    2,
                                                    true
                                                )}
                                            </span>
                                        </Col>
                                    </Row>
                                )}
                            </div>
                        );
                    }}
                </Formik>
            </div>

            <div className="mt-auto d-flex justify-content-end buttons-container">
                <button
                    className="btn btn-outline-secondary mr-2"
                    onClick={() => {
                        props.onClose();
                    }}>
                    Cancel
                </button>
                <button
                    className="btn btn-primary"
                    onClick={() => {
                        formRef?.current?.handleSubmit();
                    }}>
                    {'Change Tempo'}
                </button>
            </div>
        </div>
    );
};
